// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs-module--root--7a8fd"};